export default (refs: any[]) => {
  let newLine = `#${refs[0]}=${refs[1]}`

  for (let i = 2; i < refs.length; i++) {
    newLine += i === refs.length - 1 ? refs[i] : `${refs[i]},`
  }

  return `${newLine};\n`
}
